import {
  GET_CC_ORDER_PROCESSING_REQUEST,
  GET_CC_ORDER_PROCESSING_SUCCESS,
  GET_CC_ORDER_PROCESSING_ERROR,
  CREATE_CC_ORDER_PROCESSING_REQUEST,
  CREATE_CC_ORDER_PROCESSING_SUCCESS,
  CREATE_CC_ORDER_PROCESSING_ERROR,
} from "../actions/types";

export default function (state = [], action) {
  const { type, payload } = action;
  switch (type) {
    case GET_CC_ORDER_PROCESSING_REQUEST:
      return {
        loading: true,
      };
    case GET_CC_ORDER_PROCESSING_SUCCESS:
      return {
        ...state,
        loading: false,
        payload,
      };
    case GET_CC_ORDER_PROCESSING_ERROR:
      return {
        ...state,
        loading: false,
        payload,
      };
    case CREATE_CC_ORDER_PROCESSING_REQUEST:
      return {
        loading: true,
      };
    case CREATE_CC_ORDER_PROCESSING_SUCCESS:
      return {
        ...state,
        loading: false,
        payload,
      };
    case CREATE_CC_ORDER_PROCESSING_ERROR:
      return {
        ...state,
        loading: false,
        payload,
      };

    default: {
      return state;
    }
  }
};
